import RenderManager from "../rendering/render-manager";
import Utils from "../utils";
import * as Events from "../utils/events";
import EntranceExit from "./EntranceExit";
import Base2DElementDynamic from "./base-2d-element-dynamic";
import Transition from "./Transition";

const NSString = 'http://www.w3.org/2000/svg'; //DevSkim: ignore DS137138

class Wheel extends Base2DElementDynamic {

    get type2d() {
        return "Wheel";
    }

    get getVWSize() {
        return this._getVWSize;
    }

    _initDefaultVars() {
        super._initDefaultVars();
    }

    _initValues(options) {
        this._src = "src" in options ? options.src : this._src;
    }

    get supportsActions() { return true; }
    get content() {
        return this._content;
    }
    set content(val) {
        this._content = val;
        //this.textarea.value = val;
    }

    constructor(options, parentLayer, uuid = THREE.Math.generateUUID()) {
        super(options, parentLayer, uuid);


        const size = RenderManager.getSize();
        this.y = options.y;
        this.x = options.x;
        this.width = options.width || (300 / size.width);
        this.height = options.height || (150 / size.height);
        this.font_size = options.font_size || 1.5;
        this.animObject = {
            rotation: 0
        }
        this.rollerData = {};
        this.racetrackData = {};
        this.slots = options.slots || [
            { value: "Text 1", color: "#7CB247", txtColor: "#fff", font_size:this.font_size},
            { value: "Text 2", color: "#CBDB20", txtColor: "#fff", font_size:this.font_size},
            { value: "Text 3", color: "#2cc121", txtColor: "#fff", font_size:this.font_size},
        ];
        this.paletteId = options.paletteId || false;
        this.speed = options.speed || 10,
        this.degree = options.degree || Math.random()*360,
        this.obj = null,
        this.stop = options.stop || false,
        this.min_duration = options.min_duration || 3000,
        this.max_duration = options.max_duration || 8000,
        this.color_pointer = options.color_pointer || "#FFB200"
        this.sizeSm = options.sizeSm ? options.sizeSm : {
            x: 0.05,
            y: 0.05,
            width: 0.5,
            height: 0.075,
        };

        this.sizeLg = options.sizeLg ? options.sizeLg : {
            x: 0.3,
            y: 0.3875,
            width: 0.4,
            height: 0.225,
        };

        parentLayer.domElement.setAttribute("contains-wheel", "");

        //dom insertion
        this.svgElement = document.createElementNS(NSString, "svg");
        this.svgElement.style.pointerEvents = 'auto';

        this.pointerElement = document.createElement("div");
        this.pointerElement.className = 'wheel-pointer';

        this.spinButton = document.createElement("div");
        this.spinButton.classList.add("spin-button");
        this.spinButton.innerHTML = "SPIN"

        this.wrapperElement = document.createElement("div");
        this.wrapperElement.className = "wheel-wrapper";

        this.wrapperElement.appendChild(this.svgElement);
        this.wrapperElement.appendChild(this.spinButton);
        this.spinButton.appendChild(this.pointerElement);

        this.className = `css-${this.uuid}`;
        this.domElement.className = `q3-wheel ${this.className} ${this.extraClassname}`;        
        this.domElement.style.position = "absolute";
        this.domElement.style.display = "flex";
        this.domElement.style.alignItems = "center";
        this.domElement.style.justifyContent = "center";


        this.domElement.appendChild(this.wrapperElement);
        this.parentLayer.domElement.appendChild(this.domElement);

        if (!Q3.editMode) {
            this.spinButton.addEventListener('click', () => {
                this.start();
            });
        }

        if (Q3.editMode) {
            this.changes = 0;
        }

        if (Q3.isReady) {
            this.enterExitCtrl = new EntranceExit(this, [this.domElement]);
            this.enterExitCtrl.init(options);
        } else {
            Q3.Events.listen("tourReady", () => {
                this.enterExitCtrl = new EntranceExit(this, [this.domElement]);
                this.enterExitCtrl.init(options);
            })
        }

        if (Q3.editMode) {
            this.domElement.addEventListener('click', e => {
                this.selectHandler(e);
            }, false);
        } else {
            this.domElement.style.pointerEvents = this.disableEvents ? "none" : "auto";
            if (this.hiddenMobile) {
                this.domElement.classList.add("hidden-mobile");
            }
            if (this.hiddenDesktop) {
                this.domElement.classList.add("hidden-desktop");
            }
        }

        const {width, height} = RenderManager.getSize();

        this.redraw = this.redraw.bind(this);
        this.handleListeners(true);

        this.redraw(width, height);
        if(Q3.editMode && this.paletteId) {
            $.ajax({
                url: `${window.location.origin}${window.COOBO ? "/api" : ""}/colorpalettes/${this.paletteId}`,
                type: 'GET',
                success: data => {
                    if (data) {
                        this.palette = data;
                        this.setColors()
                    }
                },
            });
        }

    }

    setColors() {
        this.slots.forEach((s, i) => {
            this.data.slots[i].color = s.color = this.palette.colors[i%this.palette.colors.length].b;
            this.data.slots[i].txtColor = s.txtColor = this.palette.colors[i%this.palette.colors.length].t;
        })
        this.redraw();
    }

    handleListeners(add) {
        Events[add ? "listen" : "unlisten"]("viewportchanged", this.redraw);
        Events[add ? "listen" : "unlisten"]("splashremoved", this.redraw);
    }

    playLeavingAnimation() {
        this.enterExitCtrl.playLeave();
    }

    cancelLeavingAnimation() {
        this.enterExitCtrl.cancelLeave();
    }

    initActions(index) {
        if (Q3.editMode) return false;
        const action = this.slots[index].action;
        if (action) {
            action.forEach(currAction => {
                const transition = new Transition(currAction.systemAction, currAction.value, this);
                transition.click();
            });
        }
    }

    render(width, height) {
        if (!Q3.data.layers.layers2D[this.parentLayer.uuid] || this.disabled || Utils.queryParams.has("disable_2d") ) return;

        if (!this.isMounted || this.target) {
            this.redraw(width, height);
            if (width > 0 && height > 0) {
                this.isMounted = true;
            }
        }
    }

    getRenderPositionAndSize(width, height) {
        const size = RenderManager.getSize();

        if (!width) {
            width = size.width;
        }
        if (!height) {
            height = size.height;
        }

        if (!Q3.editMode && this.inLetterbox !== false) {
            width = Q3.letterbox.offsetWidth / RenderManager.pixelRatio;
            height = (Q3.letterbox.offsetHeight) / RenderManager.pixelRatio;
        }

        let w = this.width * width * RenderManager.pixelRatio;
        let h = this.height * height * RenderManager.pixelRatio;

        if (w < 40) {
            w = 40;
        }
        if (h < 40) {
            h = 40;
        }

        const [x, y] = this._calcPosition(width, height);

        return {x, y, w, h};
    }

    redraw(width, height) {

        !width && (width = RenderManager.domElement.width / RenderManager.pixelRatio);
        !height && (height = (RenderManager.domElement.height) / RenderManager.pixelRatio);

        let currentSize = this.getVWSize();
        if (this[currentSize]) {
            Object.assign(this, this[currentSize]);
        }

        const size = RenderManager.getSize();

        if (!width) {
            width = size.width;
        }

        if (!height) {
            height = size.height;
        }

        const {x, y, w: elWidth, h: elHeight} = this.getRenderPositionAndSize(width, height);


        this.domElement.style.width = elWidth + "px";
        this.domElement.style.height = elHeight + "px";
        this.domElement.style.left = (x || 0) + "px";
        this.domElement.style.top = (y || 0) + "px";

        let diameter = Math.min(elWidth, elHeight);
        let slot_count = this.slots.length
        let svg = '';
        let t = 0;
        for (var i=0; i<slot_count; i++) {
            t = this.polarToCartesian(diameter/2, diameter/2, diameter/2.20, ((i+0.5)*(360/slot_count)) );
            svg = svg + `<path d="${this.arcPath(diameter/2,diameter/2, 5, diameter/2, (i*(360/slot_count)), ((i+1)*(360/slot_count)))}" fill="${this.slots[i].color}" stroke="#000000" stroke-width="1" />`;
            svg = svg + `<text font-size="${this.slots[i].font_size}rem" x="${t.x}" y="${t.y}" fill="${this.slots[i].txtColor}" font-style="bold" font-family="Arial" alignment-baseline="central" text-anchor="start" transform="rotate(${((i+0.5)*(360/slot_count)+90)} ${t.x},${t.y})"> ${this.slots[i].value}</text>`;
        }
        this.svgElement.setAttribute("width", diameter)
        this.svgElement.setAttribute("height", diameter)
        this.svgElement.innerHTML = svg;
        
        this.pointerElement.style.borderBottomColor = this.color_pointer;
        this.spinButton.style.backgroundColor = this.color_pointer;

    }


    polarToCartesian(centerX, centerY, radius, angleInDegrees) {
        let angleInRadians = ((angleInDegrees - 90) * Math.PI) / 180.0;
        return {
          x: centerX + radius * Math.cos(angleInRadians),
          y: centerY + radius * Math.sin(angleInRadians),
        };
    }

    arcPath(x, y, radius, endradius, startAngle, endAngle) {
        let start = this.polarToCartesian(x, y, radius, endAngle);
        let end = this.polarToCartesian(x, y, radius, startAngle);
        let start2 = this.polarToCartesian(x, y, endradius, endAngle);
        let end2 = this.polarToCartesian(x, y, endradius, startAngle);
        let largeArcFlag = endAngle - startAngle <= 180 ? "0" : "1";
        let d = [
            "M", start.x, start.y, 
            "A", radius, radius, 0, largeArcFlag, 0, end.x, end.y,
            "L", end2.x, end2.y,
            "A", endradius, endradius, 0, largeArcFlag, 1, start2.x, start2.y,
            "Z"
        ].join(" ");
        return d;
    }



    start() {
        clearTimeout(this.actionTimeout);
        $(this.animObject).stop();
        let from = this.animObject.rotation;
        let to = from + this.randomInteger(196, 348) * this.randomInteger(3, 5);
        $(this.animObject).animate({rotation: to}, {
            duration: this.min_duration + (this.max_duration - this.min_duration) * Math.random(),
            step: (now)=> {
                $(this.svgElement).css({
                    transform: 'rotate(' + now + 'deg)'
                });
            },
            done:(val)=>{
                this.animObject.rotation = val.elem.rotation;
                let t = (360 - this.animObject.rotation % 360) / (360/this.slots.length)
                let selectIndex = [Math.floor(t)];
                this.actionTimeout = setTimeout(() => {
                    this.initActions(selectIndex)
                }, 1500)
            }
        });
    }

    randomInteger(min, max) {
        let rand = min - 0.5 + Math.random() * (max - min + 1);
        return Math.round(rand);
    }

    delete() {

        this.handleListeners(false);

        this.parentLayer.objects.splice(this.parentLayer.objects.indexOf(this), 1);
        this.parentLayer.domElement.removeChild(this.domElement);

        delete this.domElement;

        if (Q3.selected === this) {
            Q3.selected = null;
            Events.fire('selectchange');
        }

    }

    clone() {

        // const text = new Text({
        //     content: this.content,
        //     x: this.x + 0.01,
        //     y: this.y + 0.01,
        //     targetUuid: this.targetUuid,
        //     sizeLg: this.sizeLg,
        //     sizeSm: this.sizeSm,
        //     contentConverted: true,
        //   },
        //   this.parentLayer.clone(),
        //   THREE.Math.generateUUID()
        // );
        //
        // Q3.data.layers.layers2D[text.parentLayer.uuid].objects[text.uuid] = {
        //   type: 'text',
        //   content: text.content,
        //   x: text.x,
        //   y: text.y,
        //   targetUuid: text.targetUuid,
        //   sizeLg: text.sizeLg,
        //   sizeSm: text.sizeSm,
        // };
        //
        // this.parentLayer.objects.splice(this.parentLayer.objects.indexOf(this), 0, text);
        //
        // return text;

    }


    setData(data) {
        let currentSize = this.getVWSize();
        Object.assign(this[currentSize], {
            x: data.x,
            y: data.y,
            width: data.width,
            height: data.height
        });

        if (!Q3.data.layers.layers2D[this.parentLayer.uuid].objects[this.uuid][currentSize]) {
            Q3.data.layers.layers2D[this.parentLayer.uuid].objects[this.uuid][currentSize] = {};
        }

        Object.assign(Q3.data.layers.layers2D[this.parentLayer.uuid].objects[this.uuid][currentSize], {
            x: data.x,
            y: data.y,
            width: data.width,
            height: data.height,
        });

        this.redraw();

    }
}

export default Wheel;
export {Wheel};
